
const textfieldMultiselect = require ('../../../../../components/textfield/textfield-multiselect')

const textfieldValidator = require('../../../../../components/textfield/textfield-validator')
const validator          = require('../../../../../components/textfield/validator.min')
const snackProvider      = require('./provider-snack')
const textfieldHandler   = require('../../../../../components/textfield/textfield-handler')

let providerHtmlFc = null
let providerChatsFc = null

export function initChatsFc(chats) {
  providerChatsFc = chats
}

export function getChatsFc() {
  return providerChatsFc
}

export function initDataFc(htmlFc) {
  providerHtmlFc = htmlFc
}

export function getDataFc() {
  return providerHtmlFc
}

export function complete_bill_to_ship(htmlFc) {  

  let input_bill_to_address = htmlFc.fullcontHTML.querySelector('#provider_form_bill_to_address input').value;
  let input_bill_to_apt     = htmlFc.fullcontHTML.querySelector('#provider_form_bill_to_apt input').value;
  let input_bill_to_city    = htmlFc.fullcontHTML.querySelector('#provider_form_bill_to_city input').value;
  let input_bill_to_state   = htmlFc.fullcontHTML.querySelector('#provider_form_bill_to_state select').value;
  let input_bill_to_zip     = htmlFc.fullcontHTML.querySelector('#provider_form_bill_to_zip input').value;
  let check                 = htmlFc.fullcontHTML.querySelector("#provider_form_check_shipping_address");
  let check_value           = check.querySelector('input[type="checkbox"]').checked;

  if (check_value) {
    htmlFc.fullcontHTML.querySelector('#provider_form_ship_to_address input').value = input_bill_to_address;
    htmlFc.fullcontHTML.querySelector('#provider_form_ship_to_apt input').value     = input_bill_to_apt;
    htmlFc.fullcontHTML.querySelector('#provider_form_ship_to_city input').value    = input_bill_to_city;
    textfieldMultiselect.choose(htmlFc.fullcontHTML.querySelector('#provider_form_ship_to_state'), input_bill_to_state)
    htmlFc.fullcontHTML.querySelector('#provider_form_ship_to_zip input').value     = input_bill_to_zip;
  }

}

// function set_required(htmlFc, value) {

//   htmlFc.form.forEach((element, index) => {

//     if (element.name == "username") {
//       element.required = value;
//       htmlFc.formCopy[index].required=value;
//     }

//     if (element.name == "__password") {
//       element.required = value;
//       htmlFc.formCopy[index].required=value;

//     }

//   });

// }




export async function checkEmailInput(htmlFc,FromButton = false) {

    let emailInput = htmlFc.fullcontHTML.querySelector('#provider_form_email input');

    // Crear un nuevo objeto detailInput, para que siempre tenga el evento correcto
    let detailInput = {};
    detailInput.ev = {};
    detailInput.ev.target = emailInput;

    let email = emailInput.value.trim();

    if (validator.isEmail(email)) {

        if (!await checkEmailDB(email,htmlFc)) {
            textfieldValidator.completed(detailInput.ev);
        } else {
            textfieldValidator.incomplete(detailInput.ev, 'Email already exists');
            //solo activa el shake cuando es desde el boton save or savefromdialog
            if (FromButton) {
                textfieldHandler.error(emailInput.parentElement);
            }
            return false;
        }

    } else {
        textfieldValidator.incomplete(detailInput.ev, 'Invalid email');
        //solo activa el shake cuando es desde el boton save or savefromdialog
        if (FromButton) {
            textfieldHandler.error(emailInput.parentElement);
        }

        return false;
    }

    return true;

}


async function checkEmailDB(email,htmlFc) {

    let objToSend = { username: email };

    // Si no está en modo agregar, se agrega el dbid, ya que se está editando un registro existente
    // y se va a verificar si el username ya existe en otro usuario
    if (!htmlFc.fullcontHTML.classList.contains('mode-add')) {
        let dbid = htmlFc.fullcontHTML.getAttribute("data-dbid");
        objToSend.dbid = dbid;
    }


    const infNewData = getFormData(objToSend);

    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 30000);

    let options = {
        method: 'POST',
        body: infNewData,
        signal: controller.signal,
        credentials: 'same-origin'
    };

    try {
        const response = await fetch(`server/php/sql/checkUsername.php`, options);
        const result = await response.json();

        clearTimeout(timeout);

        if (result.code == 200) {
            return true;
        }else{
            return false;
        }

    } catch (error) {
        console.error('Error en checkEmailDB:', error);
        //esto para que se detenga el proceso si hay error
        return true;
    }
}

export function sendResetEmail(data,htmlFc) {
    let infNewData = null;
    //para saber si se enviara el correo para un nuevo usuario o para un usuario existente
    if (data.new_user) {
        infNewData =  getFormData({email: data.email, name: data.name, last_name: '', new_user: 1, type: 'password_reset', user_type: 'cliente'})
    }else{
        infNewData =  getFormData({email: data.email, name: data.name, last_name: '', type: 'password_reset', user_type: 'cliente'})
    }
    //object > FormData()
    const controller = new AbortController();
    const timeout = setTimeout(() => { controller.abort() }, 30000);

    let options = { method: 'POST', body: infNewData, signal: controller.signal, credentials: 'same-origin' };

    fetch(`server/php/send-emails/sendEmail.php`, options)
        .then(result => {
            return result.json()
        })
        .then((result) => {
            // esto es porque cuando se guarda se tiene un snack automatico, este snack se mostrara luego del principal
            let snack = document.getElementById('snack');
            if (snack.classList.contains("show")) {
                setTimeout(() => {
                    if (result.code != 200) {
                        snackProvider.start({ act: 'show', id: 'errorSendEmail', addTitle: result.message });
                    } else {
                        snackProvider.start({ act: 'show', id: 'emailWasSent' });
                    }
                }, 5500);

            } else {
                if (result.code != 200) {
                    snackProvider.start({ act: 'show', id: 'errorSendEmail', addTitle: result.message });
                } else {
                    snackProvider.start({ act: 'show', id: 'emailWasSent' });
                }
            }
        })
        .catch((error) => { // 
            console.log('result 3', 'ERRORRRRRRRR');
            throw error;
        })

}

function getFormData(object) {
    const formData = new FormData()
    Object.keys(object).forEach(key => formData.append(key, object[key]))
    return formData
}

export function sendEmailFromButton(htmlFc) {
 

    let emailInput = htmlFc.fullcontHTML.querySelector('#provider_form_email input');
    let email = emailInput.value.trim();
    let name = '';

    htmlFc.form.forEach(element => {
        if (element.name === 'name') {
            name = element.value;
        }
    });

    sendResetEmail({ email: email, name: name, last_name: "", new_user: false }, htmlFc);

}

export function showButtonResetPassword(htmlFc) {
    let resetButton = htmlFc.fullcontHTML.querySelector('.reset_password');
    resetButton.classList.remove('dn');
}

export function hideButtonResetPassword(htmlFc) {
    let resetButton = htmlFc.fullcontHTML.querySelector('.reset_password');
    resetButton.classList.add('dn');
}
